import { Daily5State } from '../types'
import { readDaily5State } from '../controllers/state'
import { useEffect, useState } from 'react'

const useDaily5State = () => {
	const [daily5State, setDaily5State] = useState<Daily5State | null>(readDaily5State())

	useEffect(() => {
		function updateState() {
			setDaily5State(readDaily5State())
		}
		document.addEventListener('DAILY5_STATE_CHANGE', updateState)
		return () => document.removeEventListener('DAILY5_STATE_CHANGE', updateState)
	}, [])

	return daily5State
}

export default useDaily5State
